import CurrentMileagePage from "./CurrentMileagePage"

export default CurrentMileagePage
